import { toast } from "react-toastify"

import { REQ } from "constants/api/requests"
import { IResponse } from "constants/interfaces"

import useApi from "util/api"

import { AdminPreference, UpdateAdminPreferencePayload } from "./type"

class PreferencesService {
  public async getMyPreferences(): Promise<AdminPreference | void> {
    try {
      const { data } = await useApi.get<IResponse<AdminPreference>>(REQ.ADMIN_DASHBOARD.PREFERENCES.GET)
      if (data.success) return data.response
    } catch (error: any) {
      // Logged, not toasted: this runs unprompted at login alongside the other background boot
      // loads, and the caller degrades to the locally stored preference. A toast here would put
      // an error in front of every admin for something they did not ask for and cannot act on.
      console.error("[Preferences] failed to load:", error)
    }
  }

  public async updateMyPreferences(payload: UpdateAdminPreferencePayload): Promise<AdminPreference | void> {
    try {
      const { data } = await useApi.patch<IResponse<AdminPreference>>(REQ.ADMIN_DASHBOARD.PREFERENCES.UPDATE, payload)
      if (data.success) return data.response
    } catch (error: any) {
      toast.error(error?.response?.data?.message || error?.message || "Failed to update preferences")
    }
  }
}

export const preferencesService = new PreferencesService()
